import React, {useContext, useEffect, useState} from "react";
import {SettingsContext} from "/src/SettingsContext";
import {VisitedContext} from "/src/VisitedContext";
import {useLocation, useParams} from "react-router-dom";

import VideoBlock from "@/components/page/VideoBlock";
import AudioBlock from "@/components/page/AudioBlock";
import TextBlock from "@/components/page/TextBlock";
import PhotoBlock from "@/components/page/PhotoBlock";
import LinkBlock from "/src/components/page/LinkBlock";
import {useTranslation} from "react-i18next";
import i18n from "i18next";
import axios from "axios";
import {useOverlay} from "@/OverlayContext";

export default function Info({ onContentLoaded }) {

    const { tourSettings } = useContext(SettingsContext);
    const visitedContext = useContext(VisitedContext);
    const params = useParams();
    const location = useLocation();
    const { t } = useTranslation();
    const [pageContent, setPageContent] = useState("")
    const { setOverlayTitle } = useOverlay();

    useEffect(() => {

        // Track page view
        var _paq = window._paq = window._paq || [];
        _paq.push(['setCustomUrl', location.pathname]);
        _paq.push(['setDocumentTitle', 'Info']);
        _paq.push(['trackPageView']);
    }, [location]);

    React.useEffect (() => {
        console.log('Info component mounted');
        console.log("Language from URL params:", params, params.language);
        console.log(tourSettings);

        // fetch page details
        if (tourSettings.introduction_page_id) {
            loadContent();
        }

    }, [tourSettings, i18n.language, onContentLoaded]);

    const loadContent = async () => {
        console.log('Load content of page:', tourSettings.introduction_page_id);

        // get point
        setPageContent("");
        let requestParams = {
            ...({
                "lang": i18n.language
            }),
        }
        try {
            const response = await axios.get(process.env.CLIENT_API_URL + "/client/content/" + tourSettings.introduction_page_id, { params: requestParams}) // get page
            let content = response.data;
            setPageContent(content);
            setOverlayTitle(t('information'));
            visitedContext.setVisitedInfoPage(true)
            if (onContentLoaded) {
                onContentLoaded();
            }
        } catch (error) {
            console.error('Error loading content:', error);
        }
    }

    return (
        <>
            {tourSettings && pageContent &&

                <div>
                    <div className="hidden bg-[#f3ece2] rounded-t-3xl p-4">
                        <p className="text-2xl">{ t('information') }</p>
                    </div>


                                <div className={`p-4`}>


                                    { pageContent?.blocks &&
                                        <div className="space-y-4">
                                            {pageContent?.blocks.map((item) => (
                                                <div key={item.id}>
                                                    {
                                                        {
                                                            'video': <VideoBlock item={item}/>,
                                                            'audio': <AudioBlock item={item}/>,
                                                            'text': <TextBlock item={item}/>,
                                                            'photo': <PhotoBlock item={item}/>,
                                                            'link': <LinkBlock item={item}/>
                                                        }[item.type]
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                </div>

            }
        </>
    );


}
